import { useDesk, DESK_KEY } from "./desk";
import { DESK_CH, DESK_OK } from "./deskChan";
export function proxyAsk(
  body: Record<string, unknown>,
): Promise<Record<string, any>> {
  const id = crypto.randomUUID();
  return new Promise((resolve) => {
    const hear = (event: MessageEvent) => {
      if (
        event.source !== window ||
        event.origin !== location.origin ||
        event.data?.channel !== DESK_OK ||
        event.data.id !== id
      )
        return;
      clearTimeout(timer);
      window.removeEventListener("message", hear);
      resolve(event.data);
    };
    const timer = setTimeout(
      () => {
        window.removeEventListener("message", hear);
        resolve({
          ok: false,
          error:
            "Нет подтверждения от FORQ Proxy. Проверь состояние в приложении; не повторяй открытие вслепую.",
        });
      },
      body.op === "openBooks" ? 95000 : 8000,
    );
    window.addEventListener("message", hear);
    window.postMessage({ channel: DESK_CH, id, ...body }, location.origin);
  });
}
export async function syncProxyDesk() {
  const r = await proxyAsk({ op: "status" });
  if (r.ok && r.desktop) {
    const books = Object.fromEntries(
      Object.entries(r.books || {}).map(([k, v]) => [k, (v as any).profileId]),
    );
    useDesk.setState({
      on: r.on === true,
      books,
      pair: ["", ""],
      api: r.ready ? "ok" : "bad",
      error: r.error || null,
    });
    localStorage.setItem("forq.proxy.autoopen.enabled", String(r.on === true));
  } else if (useDesk.getState().on) {
    useDesk.setState({
      api: "bad",
      error: r.error || "Нет связи с FORQ Proxy.",
    });
  }
  return r;
}
export function legacyDesk() {
  try {
    return JSON.parse(localStorage.getItem(DESK_KEY) || "{}");
  } catch {
    return {};
  }
}
